module.exports = __webpack_public_path__ + "static/media/dueAlert.07fbd039.png";